import {BaseLinkParams} from "../../../infrastructure/models/link/base-link-params";

export class MyScoresLinkParams extends BaseLinkParams {
  filter: String;

  constructor(filter: String) {
    super();

    this.filter = filter;
  }
}
